import Cookies from "js-cookie";
import storeAsSecureCookie from "manifest-core/utils/storeAsSecureCookie";
import { ACCESS_TOKEN, LOGGED_IN, TENANT_ID } from "../constants";

export const CookiePaths = {
  ACCESS_TOKEN,
  TENANT_ID,
};

const clearAllCookies = () => Object.values(CookiePaths).forEach((path) => Cookies.remove(path));

const Session = {
  clearSession() {
    window.sessionStorage.clear();
    clearAllCookies();
  },
  get accessToken() {
    return Cookies.get(CookiePaths.ACCESS_TOKEN) || "";
  },
  set accessToken(val: string) {
    storeAsSecureCookie(CookiePaths.ACCESS_TOKEN, val);
  },
  get loggedIn() {
    return window.sessionStorage.getItem(LOGGED_IN) === "true";
  },
  set loggedIn(val: boolean) {
    window.sessionStorage.setItem(LOGGED_IN, `${val}`);
  },
  get tenantId() {
    return Cookies.get(CookiePaths.TENANT_ID) ? parseInt(Cookies.get(CookiePaths.TENANT_ID) || "") : -1;
  },
  set tenantId(val: number) {
    storeAsSecureCookie(CookiePaths.TENANT_ID, val);
  },
};

export const clearCookiesOnStartup = () => {
  if (!Session.loggedIn) {
    Session.clearSession();
  }
};

export const migrateStorageToCookies = () => {
  if (window.sessionStorage.getItem(ACCESS_TOKEN)) {
    Session.accessToken = window.sessionStorage.getItem(ACCESS_TOKEN) || "";
    window.sessionStorage.removeItem(ACCESS_TOKEN);
  }
};

export default Session;
